export default __webpack_public_path__ + "static/media/reminder.452659d2.svg";